import React from 'react';

export class About extends React.Component{
    render(){
        return (
        <div>
                <div className="page-header">
                    <h1>Solution Monitor</h1>
                </div>

                <p className="lead">
                The Solution monitor is a tool created to help oversee the management of different WebMethods solutions.<br />
                It is designed and created by Advania<br /><br />
                </p>
         </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/about.js